// extracted by mini-css-extract-plugin
export var blog = "blogPreview-module--blog--6905a";
export var description = "blogPreview-module--description--d6fb3";
export var title = "blogPreview-module--title--781cd";